import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Notice, Grid, GridColumn, Button, AnalyticsTrigger, Separator } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { useInternetNotices } from '../InternetNoticesProvider';
import { getIsDealerFromAuth } from '../util/InternetCalculatorUtil';
export const DebtOrNegativeCreditNotice = () => {
    const translate = React.useContext(TranslationsContext).translate;
    const { creditAllowedState } = useInternetNotices();
    const { urlData, auth, isSecureNet } = useInternetCalculator();
    const hasDebtError = creditAllowedState.errorCodes.includes('DEBT_TELIA');
    const isDealer = getIsDealerFromAuth(auth);
    const renderNotice = (isDealerVariant) => {
        let labelPrefix = isSecureNet ? 'secureNetCalculator' : 'internetCalculator';
        labelPrefix = labelPrefix.concat(isDealerVariant ? '.dealer' : '');
        const noticeTranslationText = hasDebtError ? `${labelPrefix}.debt` : `${labelPrefix}.negativeRating`;
        return (React.createElement(Notice, { type: isDealerVariant ? 'employee' : 'error', align: "center" },
            React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
                React.createElement(GridColumn, { width: ['xs', 'max-sm'], align: ['middle-xs'] },
                    React.createElement("p", null, translate(noticeTranslationText))),
                hasDebtError && (React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                    React.createElement(AnalyticsTrigger, { trigger: { id: 'Link - CannotOrderNotice - arved', callback: 'onClick' } },
                        React.createElement(Button, { size: "small", text: translate('internetCalculator.viewBills'), url: `${urlData.getSelfServiceLink('/arved')}`, iconRight: "#arrow-right" })))))));
    };
    return (React.createElement(React.Fragment, null,
        isDealer && (React.createElement(React.Fragment, null,
            renderNotice(true),
            React.createElement(Separator, { spacing: 'xsmall', color: "invisible" }))),
        renderNotice(false)));
};
